import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faAnglesDown,
  faCar,
  faChevronDown,
  faChevronRight,

  faDownload,

  faEraser,
  faMagnifyingGlass,
  faPen,
  faPrint,
  faRotate,
  faSearch,
  faShield,
  faXmark,
  faArrowLeft,
  faCamera,
  faCopy,
  faVideo,
  faLink,
  faArrowUpRightFromSquare,

  //Aba consulta de multa
  faEdit,
  faUser,
  faBarcode,
  faEnvelope,
  faBalanceScale,
  faEye,
  faHouse,
  faTriangleExclamation,
  faCircleInfo,
  faAnglesUp,
  faCircleExclamation,

  //Icones Url Serviços
  faTrafficLight,
  faIdCard,
  faFilePen,
  faFileArrowDown,
  faMoneyBillTransfer,
  faFileCircleMinus,
  faFileCircleExclamation,
  faUserShield,
  faMobileScreenButton,
  faFileInvoiceDollar
   
} from '@fortawesome/free-solid-svg-icons'

import { 
  faAddressCard,
  faCircleQuestion,
  faFileAlt,
  faFileLines,
  faSquarePlus,
  faSquareMinus,
  faFileExcel
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faAddressCard,
  faAnglesDown,
  faCar,
  faCircleQuestion,    
  faDownload,  
  faEraser,
  faFileAlt,
  faFileLines,
  faMagnifyingGlass,
  faPen,
  faPrint,
  faRotate,
  faSearch,
  faShield,
  faUser,  
  faChevronRight,  
  faChevronDown , 
  faXmark,
  faEdit,
  faBarcode,
  faEnvelope,
  faBalanceScale,
  faEye,
  faSquarePlus,
  faSquareMinus,
  faHouse,
  faTriangleExclamation,
  faArrowLeft,
  faCircleInfo,
  faCamera,
  faCopy,
  faVideo,
  faLink,
  faArrowUpRightFromSquare,
  faAnglesUp,
  faTrafficLight,
  faIdCard,
  faFilePen,
  faFileArrowDown,
  faMoneyBillTransfer,
  faFileCircleMinus,
  faFileCircleExclamation,
  faUserShield,
  faMobileScreenButton,
  faFileInvoiceDollar,
  faFileExcel,
  faCircleExclamation
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
